import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=12ecc8be&"
import script from "./SkillsSection.vue?vue&type=script&lang=js&"
export * from "./SkillsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports